import { HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { finalize, Observable, tap } from 'rxjs';
import { AutoMlService } from '../service/auto-ml.service';
@Injectable({
  providedIn: 'root'
})
export class InterceptorService {

  constructor(
    private helper: AutoMlService,
    private router: Router,
  ) { }

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    //this.layoutService.isLoading = true;

    return next.handle(httpRequest).pipe(
      // finalize(() => this.layoutService.isLoading = false),
      tap((event: any) => {
        if (event instanceof HttpResponse) {
        }
      },
        (error: any) => {
          if (error.status == 401) {
            this.router.navigateByUrl('login').then(()=>{
              let d:Date = new Date();
              d.setTime(d.getTime() + -1 * 24 * 60 * 60 * 1000);
              let expires:string = `expires=${d.toUTCString()}`;
              document.cookie = `token='';${expires}`
              // location.reload();
            });
            // this.toast.error('Unauthenticated...')

          }
        }
      )
    )
  }

}
